<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Add Purchase</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div>
            </div>
            <b-row>
             <b-col sm="4">
              <b-form-group>
                <label for="name">Supplier Name</label>
                <span style="display: flex;">
                  <model-list-select :list="suppliername" option-value="sup_cmp_name" :custom-text="nameAndnumber" v-model="selectedcustomer" @input="onSelectSup($event)" placeholder="Search Supplier Name" @searchchange="searchsupplier"></model-list-select>&nbsp;&nbsp;
                    <button v-if="sup_rights === true" type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier" @click="addSupplier()"><i class="fa fa-user"></i></button>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Shop Name</label>
                  <span style="display: flex;">
                    <model-list-select @input="onSelectShp($event)" :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="selectshop" placeholder="Select Shop" @searchchange="searchshops"></model-list-select>&nbsp;&nbsp;
                    <button type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Scan Barcode</label>
                  <input type="text" class="form-control" name="barcode" v-model="barcode" @blur="searchBarcode" autocomplete="off"  @keyup="checkShop" placeholder="Enter Product Barcode Number">&nbsp;&nbsp;
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.barcode}}</strong></small>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">ITEM DETAILS</span>
            <strong> <span style="float:right">Today's Gold Rate : <input type="text" class="form-control-sm" autocomplete="off"  :value="charge" style="width: 22%;font-size:18px;height:20px;color:black" disabled> {{new Date().toDateString()}} </span></strong>
          </div>
          <div class="card-body" style="padding:0px !important;">
            <div class="">
<table class="table table-striped table-responsive">
  <thead>
    <tr style="font-size: 12px; text-align: center;">
      <th width="1%">#</th>
      <th :width="selectedCategoryType === 'silver' ? '20%' : '14%'" style="padding-bottom:20px;">Product Name</th>
      <!-- Description column reduced -->
      <th v-if="selectedCategoryType === 'silver'" width="17%" style="padding-bottom:20px;">Description</th>
      <th v-if="selectedCategoryType === 'silver'" :width="selectedCategoryType === 'silver' ? '5%' : '10%'" style="padding-bottom:20px;">Purity</th>
      <th v-if="selectedCategoryType == 'gold'" width="4%" style="padding-bottom:20px;">Carat</th>
      <th width="5%">Gross weight(gm)</th>
      <th v-if="selectedCategoryType == 'gold'" width="7%">Stone Weight(gm)</th>
      <th v-if="selectedCategoryType == 'gold'" width="6%" style="padding-bottom:20px;">Wastage(gm)</th>
      <th v-if="selectedCategoryType == 'gold'" width="6%">Net weight</th>
      <th v-if="selectedCategoryType == 'gold'" width="8%">Stone Price</th>
      <th width="5%">Quantity</th>
      <th v-if="selectedCategoryType == 'gold'" width="6%" style="padding-bottom:20px;">Price/gram</th>
      <th v-if="selectedCategoryType === 'silver'" width="9%" style="padding-bottom:20px;">Price/Gram</th>
      <th width="6%">Making charges</th>
      <th width="6%" v-if="is_cs_gst" style="padding-bottom:20px;">SGST %</th>
      <th width="6%" v-if="is_cs_gst" style="padding-bottom:20px;">CGST %</th>
      <th width="6%" v-if="is_i_gst" style="padding-bottom:20px;">IGST %</th>
      <!-- Total column widened -->
      <th width="16%" style="padding-bottom:20px;">Total</th>
      <th width="6%" style="padding-bottom:20px;">Other</th>
    </tr>
  </thead>

  <tbody id="product_table_body">
    <tr v-for="(row, index) in rows">
      <td>
        <a style="font-size:14px;color: #20a8d8; cursor:pointer;" @click="addProduct(row,index)">
          <i class="fa fa-plus" v-b-tooltip.hover title="Add New Product"></i>
        </a>
      </td>
      <td :style="selectedCategoryType === 'silver' ? 'width:20%' : 'width:14%'">
        <model-list-select
          :list="row.productnamex"
          option-value="product_id"
          option-text="product_name"
          v-model="row.selectproductrow"
          placeholder="Find Product Name"
          @input="openvariant($event,index)"
          @searchchange="searchprd3($event,index,row)"
          style="white-space: nowrap; -webkit-text-fill-color: rgb(83, 108, 121) !important; height:30px !important; border: 1px solid rgb(194, 207, 214); min-height: 30px; border-radius: 1px; padding-top: 6px;"
          class="product-drop"
          id="productlist"
        ></model-list-select>
        <small class="form-text text-muted">
          <strong style="color: red;">{{ haserror.prodct }}</strong>
        </small>
      </td>

      <!-- Description column reduced -->
      <td v-if="selectedCategoryType === 'silver'" style="width:10%; text-align: center; position: relative;">
        <span style="display: flex;">
          <textarea
            v-model="row.product_desc"
            :placeholder="row.product_desc ? '' : '--'"
            style="width: 100%; -webkit-text-fill-color: rgb(83, 108, 121) !important; height:25px !important; border: 1px solid rgb(194, 207, 214); min-height: 27px; border-radius: 1px; padding-top: 6px; text-align: center; transition: all 0.3s ease; resize: none; overflow: hidden;"
            v-on:focus="expandInput"
            v-on:blur="shrinkInput"
          ></textarea>
        </span>
      </td>
                    <td v-if="selectedCategoryType === 'silver'" :style="selectedCategoryType === 'silver' ? 'width:5%' : 'width:10%'">
                      <span style="display: flex;">
                        <input
                          v-model="row.purity"
                          @change="price(index, charge);"
                          style="width: 100%; white-space: nowrap; -webkit-text-fill-color: rgb(83, 108, 121) !important; height:25px !important; border: 1px solid rgb(194, 207, 214); min-height: 27px; border-radius: 1px; padding-top: 6px;">
                      </span>
                    </td>
                    <td v-if="selectedCategoryType == 'gold'">
                      <span style="display: flex;">
                        <model-list-select :list="caratval" option-value="carat_value" option-text="carat_value" v-model="row.selectcarat" placeholder="crt" @input="onSelectcarat($event,index,charge)" @searchchange="searchcaratval" id="carat_value" v-on:change="price(index,charge);" style=" white-space: nowrap; -webkit-text-fill-color: rgb(83, 108, 121) !important; height:25px !important; border: 1px solid rgb(194, 207, 214); min-height: 27px; border-radius: 1px; padding-top: 6px;"></model-list-select>
                      </span>
                    </td>
                    <td>
                      <input type="text" class="form-control-sm" autocomplete="off" v-model="row.weight" style="width: 100%;" v-on:change="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_weight!=''">{{row.err_weight}}</small>
                    </td>
                    <td v-if="selectedCategoryType == 'gold'">
                      <input type="text" class="form-control-sm" autocomplete="off" v-model="row.stone_weight" style="width: 100%;" v-on:blur="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_stone_weight!=''">{{row.err_stone_weight}}</small>
                    </td>
                    <td v-if="selectedCategoryType == 'gold'">
                      <input type="text" class="form-control-sm" autocomplete="off" v-model="row.wastage" style="width: 100%;" v-on:blur="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_wastage!=''">{{row.err_wastage}}</small>
                    </td>
                    <td v-if="selectedCategoryType == 'gold'">
                      <input type="text" class="form-control-sm" autocomplete="off" v-model="row.netweight" style="width: 100%;" disabled="" v-on:blur="price(index,charge);">
                    </td>
                    <td v-if="selectedCategoryType == 'gold'">
                      <input type="text" class="form-control-sm" autocomplete="off" v-model="row.stone_price" style="width: 100%;" v-on:blur="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_stone_price!=''">{{row.err_stone_price}}</small>
                    </td>
                    <td>
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        v-model="row.qty"
                        class="form-control-sm"
                        v-on:change="price(index, charge)"
                        id="qty"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_qty!=''">{{row.err_qty}}</small>
                    </td>
                    <td v-if="selectedCategoryType == 'gold'">
                      <input type="text" style="width: 100%;" autocomplete="off" v-model="row.price" class="form-control-sm" v-on:change="price(index,charge);" id="cost">
                      <small style="font-size: 10px; color: red;" v-if="row.err_price!=''">{{row.err_price}}</small>
                    </td>
                    <td v-if="selectedCategoryType === 'silver'">
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        v-model="row.price"
                        class="form-control-sm"
                        v-on:change="price(index, charge)"
                        placeholder="Price/Gram"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_price!=''">{{row.err_price}}</small>
                    </td>
                    <td>
                      <input type="text" style="width: 100%;" autocomplete="off" v-model="row.making_charges" class="form-control-sm" v-on:change="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_making_charges!=''">{{row.err_making_charges}}</small>
                    </td>
                    <td v-show="is_cs_gst">
                      <input type="text" style="width: 100%;" autocomplete="off" class="form-control-sm" v-model="row.sgst" v-on:change="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_sgst!=''">{{row.err_sgst}}<br></small>
                    </td>
                    <td v-show="is_cs_gst">
                      <input type="text" style="width: 100%;" autocomplete="off" class="form-control-sm" v-model="row.cgst" v-on:change="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_cgst!=''">{{row.err_cgst}}<br></small>
                    </td>
                    <td v-show="is_i_gst">
                      <input type="text" style="width: 100%;" autocomplete="off" class="form-control-sm" v-model="row.igst" v-on:change="price(index,charge);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_igst!=''">{{row.err_igst}}<br></small>
                    </td>
                    <td>
                      <input type="text" disabled="disabled" autocomplete="off" v-model="row.amttotal" style="width: 100%;" class="form-control-sm">
                    </td>
                    <td>
                      <center>
                        <i class='fa fa-bell bell' style="color: red;" v-b-tooltip.hover title="Sale Adjustment" @click="onSelectAdjustment(index,row)" v-if="row.is_adjustment"></i>
                        <i class="fa fa-reorder" style="color: #20a8d8;" v-b-tooltip.hover title="Add More option" variant="secondary" @click="openmodal(index)"></i>
                        <i class="fa fa-trash-o" style="color: #F44336;" v-b-tooltip.hover title="Delete" v-on:click="removeElement(index);"></i></center>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div style="font-size: 13px; color: green;">Add New Row
                       <span style="cursor: pointer;" @click="addRow1" class="badge badge-pill badge-info" v-b-tooltip.hover title="Add New Row">Add</span></div>
                    </td>
                    <td style="text-align: right;" colspan="15">Total Amount Before Tax:
                      <input type="text" class="form-control-sm" :value="totalamt" disabled="">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td style="text-align: right;" colspan="15"><span style="margin-right:25px;">Additional Discount : </span>
                      <input type="text" class="form-control-sm" autocomplete="off" v-on:change="sgstsss" v-model="detail.addition">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td style="text-align: right;" colspan="15"><span style="margin-right:120px;">SGST: </span><input type="text" class="form-control-sm" enabled="" :value="totalsgst"></td>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td style="text-align: right;" colspan="15"><span style="margin-right:120px;">CGST:</span>
                     <input type="text" class="form-control-sm" disabled="" :value="totalcgst">
                   </td>
                 </tr>
                 <tr>
                  <td colspan="2"></td>
                  <td style="text-align: right;" colspan="15"><span style="margin-right:125px;">IGST: </span>
                    <input type="text" class="form-control-sm" disabled="" :value="totaligst">
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: left;">Payment Type:</td>
                  <td colspan="2" style="text-align: left;">
                    <b-form-select v-model="selected_pytype" :options="lst_paymenttype" v-on:change="paychange"></b-form-select>
                  </td>
                 <td style="text-align: right;" colspan="15"><span style="margin-right:44px;">Total Tax Amount : </span>
                   <input type="text" :value="totaltax" disabled="" class="form-control-sm">
                 </td>
               </tr>
               <tr>
                <td colspan="4" style="text-align: left;">
                  <b-form-group label="">
                    Payment Mode:
                    <b-form-radio v-model="selected_pymode" name="payment_mode" value="cash" v-on:change="modechange">Cash</b-form-radio>
                    <b-form-radio v-model="selected_pymode" name="payment_mode" value="cheque" v-on:change="modechange">Cheque</b-form-radio>
                  </b-form-group>
                </td>
                <td colspan="15" style="text-align: right;"><span style="margin-right:29px;">Total Amount To Pay:</span> <input type="text" :value="totalamtpay" disabled="" class="form-control-sm"></td>
              </tr>
              <tr v-if="fullpay === true">
                <td colspan="2"></td>
                <td colspan="15" style="text-align: right;"><span style="margin-right:75px;">Amount Paid:</span> <input type="text" disabled class="form-control-sm" :value="totalamtpay"><br>
                </td>
              </tr>
              <tr v-if="parpay === true">
                <td colspan="2"></td>
                <td colspan="15" style="text-align: right;"><span style="margin-right:75px;">Amount Paid: </span><input type="text" class="form-control-sm" v-model="totalparamtreceived" v-on:change="calbalance();"><br>
                  <small style="font-size: 10px; color: red;" v-if="amt_rec != ''" >{{amt_rec}}</small>
                </td>
              </tr>
              <tr v-if="parpay === true">
                <td colspan="2"></td>
                <td colspan="15" style="text-align: right;"><span style="margin-right:107px;">Balance:</span> <input type="text" class="form-control-sm" disabled="" v-model="bal"></td>
              </tr>
              <tr v-if="chqpay === true">
                <td colspan="2"></td>
                <td colspan="15" style="text-align: right;"><span style="margin-right:79px;">Cheque No.:</span> <input type="text" name="cheque_no" autocomplete="off" v-model="cheque_no" class="form-control-sm" placeholder="Enter Cheque No"><br>
                  <small style="font-size: 10px; color: red;" v-if="chequeno_validate != ''" >{{chequeno_validate}}</small>
                </td>
              </tr>
              <tr v-if="chqpay === true">
                <td colspan="2"></td>
                <td colspan="15" style="text-align: right;"><span style="margin-right:23px;">Cheque Date.:</span> <date-picker v-model="cheque_date" editable lang="en" class="form-control-sm"></date-picker><br>
                  <small style="font-size: 10px; color: red;" v-if="chequedate_validate != ''" >{{chequedate_validate}}</small>
                </td>
              </tr>
            </tbody>
          </table>
          <b-modal title="Add More Option" no-close-on-esc no-close-on-backdrop v-model="largeModal" class="modal-info" hide-footer @ok="largeModal = false">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Batch</label>
                  <input type="text" class="form-control" autocomplete="off" name="cmp_phone" v-model="batchmd" placeholder="Enter Batch">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Serial Number </label>
                  <input type="text" class="form-control" autocomplete="off" v-model="serialmd" placeholder="Enter Serial Number">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Discount Percentage</label>
                  <input type="text" class="form-control" name="cmp_phone" v-model="percentagemd" autocomplete="off" placeholder="Enter Discount Percentage">
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.dis}}</strong></small>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Discount Amount </label>
                  <input type="text" class="form-control" autocomplete="off" v-model="amtmd" placeholder="Enter Discount Amount">
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.amt}}</strong></small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group"><br>
                  <label for="name">Tax Inclusive</label>
                  <input type="checkbox" name="cmp_inclusive" autocomplete="off" v-model="inclusive">
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.inclusive}}</strong></small>
                </div>
              </div>
            </div>
            <div class="card-footer modal_footer">
              <button type="submit" class="btn btn-sm btn-primary" @click="savemodal(indexval)"><i class="fa fa-dot-circle-o"></i> Save</button>
            </div>
          </b-modal>
          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit"><i class="fa fa-dot-circle-o"></i> Save Details</button>
        </div>
      </div>
    </div>
    <b-modal class="modal-info" size="lg" title="Sale Adjustment" no-close-on-esc no-close-on-backdrop v-model="Adjustment" hide-footer @ok="Adjustment">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 alert alert-danger" v-if="haserror.message1!=''" style="text-align:center;">{{haserror.message1}}</div>
        </div>
      </div>
      <vue-good-table @on-select-all="selectAll" @on-row-click="toggleSelectRow" :columns="columnsadj" :rows="rowsadj" :select-options="{ enabled: true }" :search-options="{ enabled: true }" styleClass="vgt-table striped bordered table-sm condensed"></vue-good-table>
      <div class="card-footer modal_footer">
        <button :disabled="disabled == 1 ? true : false" type="submit" class="btn btn-sm btn-primary" @click="save_adjustment()">
          <i class="fa fa-dot-circle-o"></i> Save</button>
      </div>
    </b-modal>
    <b-modal
      title="Plan Limit Reached"
      size="sm"
      class="modal-warning"
      ok-only
      v-model="plan_modal">
      <b-row>
        <b-col sm="2">
            <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
          </b-col>
          <b-col sm="10">
            <b-row>
            <b>You have hit the plan limit.</b>
            </b-row>
            <b-row>
              You have reached the limit of adding Supplier. Please upgrade your plan to add more Suppliers.
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        title="Plan Limit Reached"
        size="sm"
        class="modal-warning"
        ok-only
        v-model="shopplan_modal">
      <b-row>
        <b-col sm="2">
            <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
          </b-col>
          <b-col sm="10">
            <b-row>
            <b>You have hit the plan limit.</b>
            </b-row>
            <b-row>
              You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
  </div>
</template>

<script>
import Spinner from '../../spinner.vue'
import DatePicker from 'vue2-datepicker'
import { min } from 'moment'

export default {
  components: {
    'date-picker': DatePicker,
    Spinner
  },
  data() {
    return {
      silverInputMode: 'price', // Default to price for silver
      silverInputOptions: [
        { value: 'price', text: 'Price/Gram' }
      ],
      columnsadj: [
        {
          label: 'Sales ID',
          field: 'sale_id',
          width: '10% !important'
        },
        {
          label: 'Product Name',
          field: 'productname',
          width: '30% !important'
        },
        {
          label: 'Variant',
          field: 'variant',
          width: '15% !important'
        },
        {
          label: 'Qty',
          field: 'qty',
          width: '5% !important'
        },
        {
          label: 'Amount Per Unit',
          field: 'amount',
          width: '20% !important'
        },
        {
          label: 'Date',
          field: 'createdAt',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'MMM Do YY',
          width: '20% !important'
        },
      ],
      clf_time: false,
      categoryopt: [],
      matchingCategories: [],
      selectedCategoryType: null,
      disabled: 0,
      amt_rec: '',
      chequeno_validate: '',
      chequedate_validate: '',
      rowsadj: [],
      current_index: null,
      is_cs_gst: true,
      is_i_gst: true,
      Adjustment: false,
      loading: false,
      variantindex: null,
      smallmodal: false,
      plan_modal: false,
      shopplan_modal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      bal: 0,
      totalamtreceived: '',
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      selected_pytype: 'full',
      lst_paymenttype: [
        { value: 'full', text: 'Full' },
        { value: 'partial', text: 'Partial' },
        { value: 'no', text: 'No' },
      ],
      selected_pymode: 'cash',
      selectedcustomer: null,
      company_gst: '',
      supplier_gst: '',
      variantdata: null,
      batchmd: '',
      serialmd: '',
      percentagemd: '',
      amtmd: '',
      making_charges: 0.00,
      weight: '',
      netweight: '',
      wastage: 0,
      charge: 0,
      stone_price: 0,
      stone_weight: 0,
      unit: '',
      err_stone_weight: '',
      err_stone_price: '',
      salepricemd: 0,
      onlinesaleprices: 0,
      inclusive: false,
      indexval: null,
      largeModal: false,
      suppliername: [],
      caratval: [],
      selectcarat: null,
      selectcarat_pcnt: null,
      cat_dsc: '',
      prod_lst: [],
      barcodelist: [],
      barcode: '',
      shopname: [],
      selectshop: null,
      rows: [],
      haserror: {
        amt: '',
        dis: '',
        cust: '',
        prodct: '',
        message: '',
        message1: '',
        inclusive: '',
        saleprice: '',
        shop: '',
      },
      detail: {
        totprddis: 0.00,
        transporadd: 0.00,
        addition: 0.00,
        tot: '',
        cgst: 0.00,
        sgst: 0.00,
        igst: 0.00,
        taxamt: 0,
        totalamtpay: 0,
      }
    }
  },
  computed: {
    sup_rights: function() {
      return this.$store.getters.get_sup_rights
    },
    totaldis() {
      var all = this.rows.reduce((total, row) => {
        if (Number(row.amtmd1) == 0) {
          return total + (Number(row.qty) * Number(row.price) * Number(row.percentagemd1)) / 100;
        } else {
          return total + (Number(row.amtmd1));
        }
      }, 0);
      all = all.toFixed(3);
      this.detail.totprddis = all;
      return all;
    },
    totalamt() {
      var all = this.rows.reduce((total, row) => {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(3);
      this.detail.tot = all;
      return all;
    },
    totalcgst() {
      var all = this.rows.reduce((total, row) => {
        return total + ((Number(row.cgst) * Number(row.amt)) / 100);
      }, 0);
      all = all.toFixed(3);
      this.detail.cgst = all;
      return all;
    },
    totalsgst() {
      var all = this.rows.reduce((total, row) => {
        return total + (Number(row.amt) * Number(row.sgst) / 100);
      }, 0);
      all = all.toFixed(3);
      this.detail.sgst = all;
      return all;
    },
    totaligst() {
      var all = this.rows.reduce((total, row) => {
        return total + ((Number(row.igst) * Number(row.amt)) / 100);
      }, 0);
      all = all.toFixed(3);
      this.detail.igst = all;
      return all;
    },
    totaltax() {
      var all = this.rows.reduce((total, row) => {
        return total + ((Number(row.cgst) * Number(row.amt)) / 100) + ((Number(row.sgst) * Number(row.amt)) / 100) + ((Number(row.igst) * Number(row.amt)) / 100);
      }, 0);
      all = all.toFixed(3);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay() {
      let total = this.rows.reduce((sum, row) => {
        return sum + Number(row.amttotal || 0);
      }, 0);
      if (this.detail.transporadd && !isNaN(parseFloat(this.detail.transporadd))) {
        total += parseFloat(this.detail.transporadd);
      }
      if (this.detail.addition && !isNaN(parseFloat(this.detail.addition))) {
        total -= parseFloat(this.detail.addition);
      }
      total = Math.max(0, total).toFixed(3);
      this.detail.totalamtpay = total;
      this.totalamtreceived = this.selected_pytype === 'full' ? total : this.totalamtreceived;
      return total;
    },
  },
  watch: {
    silverInputMode() {
      if (this.selectedCategoryType === 'silver') {
        for (let i = 0; i < this.rows.length; i++) {
          this.rows[i].price = '';
          if (this.rows[i].selectproductrow) {
            this.price(i, this.charge);
          }
        }
      }
    }
  },
  mounted() {
    this.categorylist("comp");
  },
  created() {
    for (var i = 0; i < 3; i++) {
      this.rows.push({
        caratval: [],
        productnamex: [],
        selectcarat: null,
        selectedproductid: '',
        weight: '',
        wastage: '',
        netweight: '',
        stone_price: '',
        stone_weight: '',
        err_stone_weight: '',
        err_stone_price: '',
        unit: '',
        unitvalue: '',
        selectproductrow: null,
        price: 0,
        qty: '',
        amt: '',
        cgst: 0.00,
        sgst: 0.00,
        igst: 0.00,
        amttotal: 0,
        batchmd1: '',
        serialmd1: '',
        percentagemd1: '',
        amtmd1: '',
        variantrow: 'n/a',
        inclusive1: false,
        making_charges: '',
        onlinesaleprice: '',
        err_saleprice: '',
        err_weight: '',
        err_wastage: '',
        err_onlinesaleprice: '',
        is_adjustment: false,
        adjustment_list: [],
        adjusted: [],
        err_qty: '',
        err_price: '',
        err_sgst: '',
        err_cgst: '',
        err_igst: '',
        avaqty: '',
        showvariant: false,
        novariant: false,
        productExist: ''
      })
    }
    this.searchshops();
    this.searchsupplier();
    this.searchcaratval();
    this.daily_goldprice();
    this.shopuser();
  },
  methods: {
    expandInput(event) {
      const rect = event.target.getBoundingClientRect();
      const parentRect = event.target.closest('td').getBoundingClientRect();
      const top = rect.top - parentRect.top;
      const left = rect.left - parentRect.left;
      event.target.dataset.originalWidth = event.target.style.width;
      event.target.dataset.originalHeight = event.target.style.height;
      event.target.style.position = "absolute";
      event.target.style.top = `${top}px`;
      event.target.style.left = `${left}px`;
      event.target.style.width = "250px";
      event.target.style.height = "80px";
      event.target.style.minHeight = "80px";
      event.target.style.whiteSpace = "normal";
      event.target.style.zIndex = "1000";
      event.target.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
      event.target.style.background = "#fff";
      event.target.style.textAlign = "left";
      event.target.style.paddingLeft = "8px";
      event.target.style.overflow = "auto";
    },
    shrinkInput(event) {
      event.target.style.position = "";
      event.target.style.top = "";
      event.target.style.left = "";
      event.target.style.width = "100%";
      event.target.style.height = "25px";
      event.target.style.minHeight = "27px";
      event.target.style.whiteSpace = "nowrap";
      event.target.style.zIndex = "";
      event.target.style.boxShadow = "";
      event.target.style.background = "";
      event.target.style.textAlign = "center";
      event.target.style.paddingLeft = "";
      event.target.style.overflow = "hidden";
    },
    addSupplier() {
      var _thiss = this
      this.loading = true;
      this.$http.get('/api/suppliers/chk_plan_count').then(function(response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true
          } else {
            _thiss.plan_modal = false
            var params = {}
            var _this = _thiss
            _thiss.$http.get('/api/countries').then(function(countries) {
              params["conopt"] = countries.data;
              var __this = _this
              _this.$http.get('/api/companytypes').then(function(response) {
                params["contyp"] = response.data;
                __this.$addsuppliermodal.showSupplier(params);
                var ___this = __this
                var timer = setInterval(function() {
                  var modal_return = ___this.$store.getters.get_supmodal;
                  if (modal_return !== null) {
                    ___this.suppliername.push(modal_return)
                    ___this.selectedcustomer = modal_return
                    clearInterval(timer);
                  }
                }, 1000);
              }).catch(function(err) {
                console.log(err)
              })
            }).catch(function(error) {
              console.log(error)
            })
          }
        } else {
          console.log('something went wrong')
        }
      }).catch(function(error) {
        console.log(error)
      });
    },
    categorylist(val) {
      if (val === "comp") {
        if (!this.clf_time) {
          this.clf_time = true;
        } else {
          return;
        }
      }
      this.$http
        .get("/api/categories")
        .then((response) => {
          this.categoryopt = response.data;
          const type = (this.$route.params.type || '').toLowerCase();
          console.log('Purchase type:', type);
          this.selectedCategoryType = type;
          console.log('selected category type:', this.selectedCategoryType);
          if (type === 'gold' || type === 'silver') {
            this.matchingCategories = this.categoryopt
              .filter(cat => cat.category_type && cat.category_type.toLowerCase() === type)
              .map(cat => cat.category_id);
            console.log('Matching category IDs:', this.matchingCategories);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addProduct(row, index) {
      var _thiss = this
      this.loading = true;
      this.$http.get('/api/companyproducts/chk_plan_count').then(function(response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true
          } else {
            _thiss.plan_modal = false
            if (_thiss.selectedcustomer == null || _thiss.selectedcustomer.supplier_id === undefined) {
              _thiss.haserror.cust = "Please Select Supplier"
            } else {
              _thiss.haserror.cust = ""
              var _this = _thiss
              _thiss.$http.get('/api/companyproducts/loadData').then(function(response) {
                if (response.data.data) {
                  _this.$addproductmodal.show(response.data.data);
                  var __this = _this
                  var timer = setInterval(function() {
                    var modal_return = __this.$store.getters.get_productmodal;
                    if (modal_return !== null) {
                      var unit = response.data.data.unitopt[0].unit_name
                      row.productnamex.push(modal_return)
                      row.selectproductrow = modal_return
                      __this.openvariant(row, index)
                      __this.displayunit(row, index, unit)
                      clearInterval(timer);
                    }
                  }, 0);
                }
              }).catch(function(error) {
                if (error.response.status === 401) {
                  localStorage.clear();
                  _this.$store.commit('SET_AUTH_USER', null)
                  _this.$router.push('/');
                }
                if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
                  localStorage.clear();
                  _this.$store.commit('SET_AUTH_USER', null)
                  _this.$router.push('/');
                }
              });
            }
          }
        } else {
          console.log('something went wrong')
        }
      }).catch(function(error) {
        console.log(error)
      });
    },
    displayunit(row, index, unit) {
      var unitname = unit
      console.log("display", unitname)
      this.rows[index]['unit'] = unitname
      console.log("display after", unitname)
    },
    addShop() {
      var _this = this
      this.loading = true;
      this.$http.get('/api/shopestablishments/chk_plan_count').then(function(response) {
        _this.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _this.shopplan_modal = true
          } else {
            _this.shopplan_modal = false
            var params = {}
            _this.$http.get('/api/countries').then(function(countries) {
              params['countries'] = countries.data
              _this.$addshopmodal.showShop(params);
              var __this = _this
              var timer = setInterval(function() {
                var modal_return = __this.$store.getters.get_shopmodal;
                if (modal_return !== null) {
                  __this.searchshops(modal_return)
                  clearInterval(timer);
                }
              }, 1000);
            }).catch(function(error) {
              console.log(error)
            });
          }
        } else {
          console.log('something went wrong')
        }
      }).catch(function(error) {
        console.log(error)
      });
    },
    addShop1() {
      var _thiss = this
      _thiss.loading = true;
      _thiss.$http.get('/api/shopestablishments/chk_plan_count').then(function(response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true
          } else {
            var params = {}
            _thiss.$http.get('/api/countries').then(function(countries) {
              params['countries'] = countries.data
              var __this = _thiss
              _this.$http.get('/api/users/allusers').then(function(alluser) {
                params['alluser'] = alluser.data
                __this.$addshopmodal.showShop(params);
                var ___this = __this
                var timer = setInterval(function() {
                  var modal_return = ___this.$store.getters.get_shopmodal;
                  if (modal_return !== null) {
                    ___this.searchshops(modal_return)
                    clearInterval(timer);
                  }
                }, 1000);
              }).catch(function(error) {
                console.log("error - " + error)
              })
            }).catch(function(error) {
              console.log("error - " + error)
            })
          }
        } else {
          console.log('something went wrong')
        }
      }).catch(function(error) {
        console.log(error)
      });
    },
    calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount')
          this.totalparamtreceived = ''
          return
        } else {
          this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3)
        }
      }
    },
    paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val
      this.fullpay = false
      this.parpay = false
      if (this.selected_pytype === 'full') {
        this.fullpay = true
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true
        } else {
          this.chqpay = false
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true
        } else {
          this.chqpay = false
        }
      } else {
        this.chqpay = false
      }
    },
    modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true
        } else {
          this.chqpay = false
        }
      } else {
        this.chqpay = false
      }
    },
    checkVariant(index) {
      if (this.variantdata == null) {
        this.rows[index].adjustment_list = []
        this.rows[index].adjusted = []
        this.rows[index].selectedproductid = null
        this.rows[index].unit = ''
        this.rows[index].product_desc = ''
        this.rows[index].purity = 0.00
        this.rows[index].selectproductrow = null
        this.rows[index].price = 0.00
        this.rows[index].qty = ''
        this.rows[index].amt = ''
        this.rows[index].cgst = ''
        this.rows[index].sgst = ''
        this.rows[index].igst = ''
        this.rows[index].batchmd1 = ''
        this.rows[index].serialmd1 = ''
        this.rows[index].is_adjustment = false
        this.rows[index].amttotal = 0
        this.rows[index].percentagemd1 = ''
        this.rows[index].amtmd1 = ''
        this.rows[index].variantrow = 'n/a'
        this.rows[index].unitvalue = ''
        this.rows[index].novariant = false
        this.rows[index].showvariant = false
        this.rows[index].inclusive1 = false
        this.rows[index].err_qty = ''
        this.rows[index].err_price = ''
        this.rows[index].err_sgst = ''
        this.rows[index].err_cgst = ''
        this.rows[index].err_igst = ''
        this.rows[index].productExist = ''
      }
    },
    checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Supplier"
        this.barcode = ''
      } else {
        this.haserror.cust = ''
      }
      if (!this.selectshop) {
        this.haserror.shop = "Select Shop"
        this.barcode = ''
      } else {
        this.haserror.shop = ''
      }
    },
    searchBarcode() {
      var _this = this
      var option = []
      var index = 0
      var addRow = 0
      var barcode = this.barcode
      this.checkShop()
      this.barcode = ''
      if (barcode) {
        this.$http.get('/api/purchasereturns/joinproduct2?barcode=' + barcode).then(function(response) {
          var valueArr = _this.rows.map(item => item)
          var rowindex = -1
          var check = valueArr.some(function(value, indx) {
            if (value.selectproductrow == null) {
              rowindex = indx
              return true
            } else {
              return false
            }
          })
          if (response.data[0] != null) {
            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length
              _this.rows.push({
                productnamex: [],
                selectedproductid: '',
                unit: '',
                unitvalue: '',
                selectproductrow: null,
                price: 0,
                qty: '',
                amt: '',
                cgst: 0.00,
                sgst: 0.00,
                igst: 0.00,
                amttotal: 0,
                batchmd1: '',
                serialmd1: '',
                percentagemd1: '',
                amtmd1: '',
                variantrow: 'n/a',
                inclusive1: false,
                making_charges: '',
                weight: '',
                wastage: '',
                netweight: '',
                stone_price: '',
                stone_weight: '',
                err_stone_price: '',
                err_stone_weight: '',
                err_weight: '',
                err_wastage: '',
                onlinesaleprice: '',
                err_saleprice: '',
                err_onlinesaleprice: '',
                is_adjustment: false,
                adjustment_list: [],
                adjusted: [],
                err_qty: '',
                err_price: '',
                err_sgst: '',
                err_cgst: '',
                err_igst: '',
                showvariant: false,
                novariant: false,
                productExist: ''
              })
            }
            _this.rows[rowindex].productnamex.push(response.data[0])
            _this.rows[rowindex].selectproductrow = response.data[0]
            _this.openvariant(response.data[0], rowindex)
          }
        }).catch(function(error) {
          console.log('error')
        })
      } else {}
    },
    carat_value(item) {
      return `${item.carat_value}`
    },
    nameAndnumber(item) {
      return `${item.sup_cmp_name} - ${item.sup_cmp_phone}`
    },
    shopuser() {
      var _this = this
      this.$http.get('/api/shopusers').then(function(response) {}).catch(function(error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },
    onSelectAdjustment(index, row) {
      this.current_index = null
      this.current_index = index
      this.haserror.message1 = ''
      this.disabled = 0
      this.Adjustment = true
      this.rowsadj = []
      for (var i = 0; i < row.adjustment_list.length; i++) {
        if (row.adjusted.length > 0) {
          var vgtSelected = false
          for (var j = 0; j < row.adjusted.length; j++) {
            if (row.adjusted[j] == row.adjustment_list[i].saleadjustment_id) {
              var vgtSelected = true
            }
          }
          this.rowsadj.push({
            sale_id: row.adjustment_list[i].saleadjustment_id,
            productname: row.adjustment_list[i].product_id,
            variant: row.adjustment_list[i].variant_id,
            qty: row.adjustment_list[i].adjusted_qty,
            amount: row.adjustment_list[i].sale_amount,
            createdAt: row.adjustment_list[i].lastupdated_datetime,
            vgtSelected: vgtSelected
          })
        } else {
          this.rowsadj.push({
            sale_id: row.adjustment_list[i].saleadjustment_id,
            productname: row.adjustment_list[i].product_id,
            variant: row.adjustment_list[i].variant_id,
            qty: row.adjustment_list[i].adjusted_qty,
            amount: row.adjustment_list[i].sale_amount,
            createdAt: row.adjustment_list[i].lastupdated_datetime,
            vgtSelected: false
          })
        }
      }
      this.checking_adjustment()
    },
    save_adjustment() {
      this.rows[this.current_index].adjusted = []
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i]['vgtSelected'] == true) {
          this.rows[this.current_index].adjusted.push(this.rowsadj[i]['sale_id'])
        }
      }
      this.Adjustment = false
    },
    selectAll(selected, selectedRows) {
      if (selected.selectedRows.length === 0) {
        var vgtSelected = false
      } else {
        var vgtSelected = true
      }
      for (var i = 0; i < this.rowsadj.length; i++) {
        this.rowsadj[i]['vgtSelected'] = vgtSelected
      }
      this.checking_adjustment()
    },
    toggleSelectRow(params) {
      this.rowsadj[params.row.originalIndex]['vgtSelected'] = params.row.vgtSelected
      this.checking_adjustment()
    },
    checking_adjustment() {
      var row_qty = this.rows[this.current_index]['qty']
      var adj_qty = 0
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i].vgtSelected) {
          adj_qty += parseFloat(this.rowsadj[i].qty)
        }
      }
      if (adj_qty > row_qty) {
        this.disabled = 1
        this.haserror.message1 = 'Adjustment Quantity Cannot Be Greater Than Purchase Quantity'
      } else {
        this.disabled = 0
        this.haserror.message1 = ''
      }
    },
    company_data() {
      this.company_gst = this.selectshop.shop_gst
    },
    onSelectShp(option) {
      this.selectshop = option
      this.haserror.shop = ''
      this.company_data();
      if (this.selectedcustomer !== null && this.selectedcustomer !== undefined)
        this.onSelectSup(this.selectedcustomer);
      if (option.id != undefined) {
        if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
          this.haserror.shop = "Please Select Shop"
        }
      } else {
        this.haserror.shop = "Please Select Shop"
      }
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.sale_adjustment(this.rows[i].selectproductrow, i)
          }
        }
      }
    },
    onSelectcarat(option, index, charge) {
      console.log("in onselectcarat")
      var price = charge
      console.log(price)
      this.haserror.cust = ''
      var status = 1
      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id === undefined) {
        status = 0
        this.haserror.cust = "Please Select Supplier here and product name below"
      }
      if (status == 1) {
        this.selectcarat = option
        console.log(this.selectcarat.carat_value)
        console.log(option)
        this.rows[index]['qty'] = 1
      }
    },
    onSelectProduct(temprow, index, option) {
      console.log(option)
      var _this = this
      this.$http.get('/api/estshopinventories?filter[where][weight]=' + temprow.weight + '&filter[where][carat_value]=' + this.selectcarat.carat_value + '&filter[where][stone_weight]=' + temprow.stone_weight + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id + '&filter[where][product_id]=' + temprow.selectproductrow.product_id).then(function(response) {
        console.log(response.data)
        if (response.data[0].variant_value === null) {
          if (response.data.length > 1) {
            _this.rows[index]['avaqty'] = response.data[1].quantity
            _this.rows[index]['carat'] = response.data[1].selectcarat.carat_value
            _this.rows[index]['priceqty'] = response.data[1].last_purprice_aft
            _this.rows[index]['total'] = '0.00'
            if (response.data[1].tax_inclusive == true) {
              _this.rows[index]['inclusive1'] = true
            } else {
              _this.rows[index]['inclusive1'] = false
            }
          } else {
            _this.rows[index]['avaqty'] = '0'
            _this.rows[index]['cgst'] = '0.00'
            console.log(response.data[0].quantity)
            _this.rows[index]['priceqty'] = '0.000'
            _this.saleprice_editable = true
            _this.rows[index]['total'] = '0.00'
            _this.saleprice_nonedit = false
            _this.rows[index]['inclusive1'] = false
          }
          _this.rows[index]['variantrow'] = 'n/a'
          _this.rows[index]['selectedproductid'] = 'n/a';
          _this.rows[index]['show1'] = true
          _this.rows[index]['show'] = false;
          _this.rows[index]['show2'] = false;
          _this.rows[index]['total'] = '0.00'
        } else {
          _this.rows[index]['show'] = true;
          _this.rows[index]['show1'] = false
          _this.rows[index]['show2'] = false
          if (response.data.length > 1) {
            if (response.data[1].tax_inclusive == true) {
              _this.rows[index]['inclusive1'] = true
              _this.rows[index]['total'] = '0.00'
            } else {
              _this.rows[index]['inclusive1'] = false
            }
            if (parseFloat(response.data[1].exp_sellprice_bft) == 0) {
              _this.saleprice_editable = true
              _this.saleprice_nonedit = false
              _this.rows[index]['total'] = '0.00'
            }
            _this.rows[index]['making_charges'] = 0.00
            _this.rows[index]['priceqty'] = response.data[1].exp_sellprice_bft
            if (response.data[1].variant_id == '') {
              _this.rows[index]['variantrow'] = 'n/a'
            } else {
              _this.rows[index]['variantrow'] = response.data[1].variant_id
            }
          } else {
            _this.rows[index]['inclusive1'] = false
            _this.rows[index]['avaqty'] = '0'
            _this.rows[index]['priceqty'] = '0.000';
            _this.rows[index]['inclusive1'] = false
            _this.saleprice_editable = true
            _this.saleprice_nonedit = false
          }
        }
        _this.price(index, charge)
      }).catch(function(err) {
        console.log(err)
      });
    },
    daily_goldprice(index, charge) {
      var _this = this
      this.$http.get('/api/goldprices/getdetails').then(function(response) {
        console.log(response.data)
        _this.charge = response.data[0].gold_rate
        console.log(_this.charge)
        _this.price(this.rows[index], index, _this.charge)
        _this.onSelectcarat(index, _this.charge)
      }).catch(function(err) {
        console.log(err)
      });
    },
    onSelectSup(option) {
      this.is_cs_gst = true
      if (option.sup_cmp_gst !== undefined) {
        this.haserror.cust = ''
        this.supplier_gst = option.sup_cmp_gst
      }
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.show_tax(this.rows[i].selectproductrow, i)
          }
        }
      }
    },
    onSelectvariant(option) {
      if (option.variant_value === 'No Variant') {
        this.rows[this.variantindex]['variantrow'] = 'n/a'
      } else {
        this.rows[this.variantindex]['variantrow'] = option.variant_value
      }
      this.smallmodal = false;
      var row = this.rows[this.variantindex].selectproductrow
      this.sale_adjustment(row, this.variantindex)
      this.onSelect(row, this.variantindex)
    },
    openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index)
      } else {
        return false
      }
    },
    openvariant(row, index) {
      this.variantindex = index
      this.variantdata = null
      this.variantvalue = []
      var _this = this
      var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id
      if (vrnt_id != null && row.category_id != 1) {
        this.rows[this.variantindex].novariant = true
        this.rows[this.variantindex].showvariant = false
        this.smallmodal = true;
        this.$http.get('/api/variantvalues?filter[where][variant_id]=' + vrnt_id).then(function(response) {
          _this.variantvalue = response.data
          _this.variantvalue.unshift({
            company_id: "I2OCGLB",
            id: 0,
            regcity_code: "I2O",
            variant_id: "0",
            variant_value: "No Variant"
          })
        }).catch(function(error) {});
      } else {
        this.rows[this.variantindex].novariant = true
        this.rows[this.variantindex].showvariant = false
        var option = {
          company_id: "I2OCGLB",
          id: 0,
          regcity_code: "I2O",
          variant_id: "0",
          variant_value: "No Variant"
        }
        this.onSelectvariant(option)
        this.smallmodal = false;
      }
    },
    sale_adjustment(option, index) {
      var _this = this
      this.$http.get('/api/salesadjustments?filter[where][est_shop_id]=' + _this.selectshop.est_shop_id + '&filter[where][product_id]=' + option.product_id + '&filter[where][variant_id]=' + _this.rows[index]['variantrow']).then(function(response) {
        if (response.data.length > 0) {
          _this.rows[index]['adjustment_list'] = response.data
          _this.rows[index]['is_adjustment'] = true
        } else {
          _this.rows[index]['adjustment_list'] = []
          _this.rows[index]['is_adjustment'] = false
          _this.rows[index]['adjusted'] = []
        }
      }).catch(function(error) {});
      this.onSelect(option, index)
    },
    show_tax(option, index) {
      var _this = this
      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + option.tax_gst_id).then(function(response) {
        console.log(response.data)
        if (_this.company_gst && _this.supplier_gst) {
          var company_gst = _this.company_gst.substring(0, 2)
          var supplier_gst = _this.supplier_gst.substring(0, 2)
          console.log(company_gst === supplier_gst)
          if (company_gst === supplier_gst) {
            _this.rows[index]['cgst'] = response.data.tax_cgst
            _this.rows[index]['sgst'] = response.data.tax_sgst
            _this.rows[index]['igst'] = 0.00
          } else {
            _this.rows[index]['cgst'] = 0.00
            _this.rows[index]['sgst'] = 0.00
            _this.rows[index]['igst'] = response.data.tax_igst
          }
        } else if (_this.supplier_gst === null || _this.supplier_gst === '') {
          _this.rows[index]['cgst'] = 0.00
          _this.rows[index]['sgst'] = 0.00
          _this.rows[index]['igst'] = 0.00
        } else {
          _this.rows[index]['cgst'] = response.data.tax_cgst
          _this.rows[index]['sgst'] = response.data.tax_sgst
          _this.rows[index]['igst'] = 0.00
        }
      });
    },
    onSelect(option, index) {
      var _this = this
      _this.rows[index]['inclusive1'] = false
      _this.current_index = null
      if (option != null) {
        if (option.alt_product_id !== undefined) {
          _this.show_tax(option, index)
          _this.rows[index]['qty'] = 1
          _this.rows[index]['unit'] = option.unit_name
          _this.rows[index]['unitvalue'] = option.unit_id
          _this.rows[index]['adjustment_list'] = []
          _this.rows[index]['adjusted'] = []
          _this.rows[index]['price'] = ''
          _this.rows[index]['making_charges'] = ''
          _this.rows[index]['wastage'] = ''
          _this.rows[index]['stone_price'] = ''
          _this.rows[index]['stone_weight'] = ''
          _this.rows[index]['netweight'] = ''
          _this.rows[index]['amttotal'] = ''
        } else {
          _this.rows[index]['selectedproductid'] = ''
          _this.rows[index]['unit'] = ''
          _this.rows[index]['unitvalue'] = ''
          _this.rows[index]['selectproductrow'] = null
          _this.rows[index]['price'] = ''
          _this.rows[index]['qty'] = ''
          _this.rows[index]['amt'] = ''
          _this.rows[index]['cgst'] = ''
          _this.rows[index]['sgst'] = ''
          _this.rows[index]['igst'] = ''
          _this.rows[index]['amttotal'] = 0
          _this.rows[index]['batchmd1'] = ''
          _this.rows[index]['serialmd1'] = ''
          _this.rows[index]['percentagemd1'] = ''
          _this.rows[index]['amtmd1'] = ''
          _this.rows[index]['variantrow'] = 'n/a'
          _this.rows[index]['inclusive1'] = false
          _this.rows[index]['making_charges'] = ''
          _this.rows[index]['onlinesaleprice'] = 0
          _this.rows[index]['adjustment_list'] = []
          _this.rows[index]['adjusted'] = []
          _this.rows[index].showvariant = false
          _this.rows[index].novariant = false
        }
      } else {
        _this.rows[index]['selectedproductid'] = ''
        _this.rows[index]['unit'] = ''
        _this.rows[index]['unitvalue'] = ''
        _this.rows[index]['selectproductrow'] = null
        _this.rows[index]['price'] = ''
        _this.rows[index]['qty'] = ''
        _this.rows[index]['amt'] = ''
        _this.rows[index]['cgst'] =
          _this.rows[index]['sgst'] =
          _this.rows[index]['igst'] =
          _this.rows[index]['amttotal'] = 0
        _this.rows[index]['batchmd1'] = ''
        _this.rows[index]['serialmd1'] = ''
        _this.rows[index]['percentagemd1'] = ''
        _this.rows[index]['amtmd1'] = ''
        _this.rows[index]['variantrow'] = 'n/a'
        _this.rows[index]['inclusive1'] = false
        _this.rows[index]['making_charges'] = 0.00
        _this.rows[index]['onlinesaleprice'] = 0
        _this.rows[index]['adjustment_list'] = []
        _this.rows[index]['adjusted'] = []
      }
    },
    openmodal(test) {
      this.largeModal = true
      this.indexval = test
      this.batchmd = '';
      this.serialmd = '';
      this.percentagemd = '';
      this.amtmd = '';
      this.salepricemd = '';
      this.onlinesaleprices = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
      this.salepricemd = this.rows[test].making_charges;
      this.onlinesaleprices = this.rows[test].onlinesaleprice;
    },
    addRow1() {
      this.rows.push({
        caratval: [],
        selectcarat: null,
        productnamex: [],
        selectedproductid: '',
        unit: '',
        unitvalue: '',
        selectproductrow: null,
        price: 0,
        qty: '',
        amt: '',
        cgst: 0.00,
        sgst: 0.00,
        igst: 0.00,
        amttotal: 0,
        batchmd1: '',
        serialmd1: '',
        percentagemd1: '',
        amtmd1: '',
        variantrow: 'n/a',
        inclusive1: false,
        making_charges: '',
        weight: '',
        wastage: '',
        netweight: '',
        err_wastage: '',
        stone_price: '',
        stone_weight: '',
        err_stone_price: '',
        err_stone_weight: '',
        err_weight: '',
        onlinesaleprice: '',
        err_saleprice: '',
        err_onlinesaleprice: '',
        is_adjustment: false,
        adjustment_list: [],
        adjusted: [],
        err_qty: '',
        err_price: '',
        err_sgst: '',
        err_cgst: '',
        err_igst: '',
        showvariant: false,
        novariant: false,
        productExist: ''
      })
    },
    removeElement: function(index) {
      this.rows.splice(index, 1);
      if (this.selected_pytype === 'partial') {
        this.bal = 0.0000
        this.totalparamtreceived = ''
      }
    },
    searchshops(shop_id) {
      var _this = this
      this.$http.get('/api/shopusers/getShop').then(function(response) {
        _this.shopname = response.data
        if (shop_id !== undefined) {
          var select_shp = _this.shopname.filter(function(each) {
            return each.est_shop_id === shop_id
          });
          _this.selectshop = select_shp[0]
          _this.company_data();
        } else {
          var len = response.data.length - 1
          _this.selectshop = response.data[len]
          _this.company_data();
        }
      }).catch(function(error) {
        console.log(error);
      });
    },
    searchprd3(searchText, index, row) {
      this.haserror.cust = '';
      this.haserror.shop = '';
      this.haserror.prodct = '';
      let status = 1;
      console.log('search has been called')
      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Supplier";
      }
      if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }
      if (status === 1 && searchText) {
        const _this = this;
        console.log('selected category type:', this.selectedCategoryType);
        const baseUrl = `/api/purchasereturns/joinproduct2?data=${searchText}`;
        let query = baseUrl;
        if (this.matchingCategories.length > 0) {
          query += `&category_ids=${this.matchingCategories.join(',')}`;
        }
        console.log(query)
        this.$http.get(query)
          .then(function(response) {
            row.productnamex = response.data;
            console.log("Response data:", response.data);
          })
          .catch(function(error) {
            console.error("Error fetching products:", error);
          });
      }
    },
    searchsupplier() {
      var _this = this
      this.$http.get('/api/suppliers').then(function(response) {
        _this.suppliername = response.data
        console.log(_this.suppliername)
      }).catch(function(error) {
        console.log(error);
      });
    },
    searchcaratval() {
      var _this = this
      this.$http.get('api/Purities/puritydetails').then(function(response) {
        _this.caratval = response.data
        console.log(response.data)
      }).catch(function(error) {
        console.log(error);
      });
    },
    savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/
      var num1 = /^[0-9]{1,12}$/
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/
      this.haserror.amt = ''
      this.haserror.dis = ''
      if (this.percentagemd != '' && this.amtmd != '') {
        this.haserror.amt = "Please Select Any One"
      } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100"
      } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Valid Amount"
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount"
      } else {
        this.rows[val]['batchmd1'] = this.batchmd
        this.rows[val]['serialmd1'] = this.serialmd
        this.rows[val]['percentagemd1'] = this.percentagemd
        this.rows[val]['amtmd1'] = this.amtmd
        this.rows[val]['inclusive1'] = this.inclusive
        this.rows[val]['onlinesaleprice'] = this.onlinesaleprices
        this.largeModal = false;
        this.price(val);
      }
    },


    trasportsss(){
        var num=/^\d{1,12}(\.\d{1,6})?$/
        if(num.test(this.detail.transporadd)==false && this.detail.transporadd!=='' ){
          this.detail.transporadd='';
          alert("Please Provide Valid Integer For Additional Discount");
        }
        if(parseFloat(this.detail.totalamtpay)<0){
          this.detail.transporadd='';
          alert("Invalid Entry" )
        }
        if(this.selected_pytype === 'partial'){
             if(this.totalparamtreceived !== ''){
               this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3)
             }
        }
    },

    sgstsss(){
        var num=/^\d{1,12}(\.\d{1,6})?$/
        if(num.test(this.detail.sgst)==false && this.detail.sgst!=='' ){
          this.detail.sgst='';
          alert("Please Provide Valid Integer For Additional Discount");
        }
        if(parseFloat(this.detail.totalamtpay)<0){
          this.detail.sgst='';
          alert("Invalid Entry" )
        }
        if(this.selected_pytype === 'partial'){
             if(this.totalparamtreceived !== ''){
               this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3)
             }
        }
    },
      discountadd(){
        // var num=/^[0-9]{1,11}$/
        var num=/^\d{1,12}(\.\d{1,6})?$/
        if(num.test(this.detail.addition)==false && this.detail.addition!=='' ){
          this.detail.addition='';
          alert("Please Provide Valid Integer For Additional Discount");
        }
        if(parseFloat(this.detail.totalamtpay)<0){
          this.detail.addition='';
          alert("Invalid Entry" )
        }
        if(this.selected_pytype === 'partial'){
             if(this.totalparamtreceived !== ''){
               this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3)
             }
           }
      },
      // MODIFIED: price method with conditional logic for silver
      price(index, charge) {
        const prc = charge;
        const num = /^[0-9]{1,11}$/;
        const price_regex = /^\d{1,12}(\.\d{1,6})?$/;
        const tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
        const igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

        if (!this.rows || !Array.isArray(this.rows) || !this.rows[index]) {
            console.error(`[price] Error: rows[${index}] is undefined or rows is not an array`);
            return;
        }

        let igst_value = 0.00;
        let total = 0;

        if (this.rows[index].sgst !== '' && !isNaN(parseFloat(this.rows[index].sgst)) && parseFloat(this.rows[index].sgst) > 0.00 && parseFloat(this.rows[index].cgst || 0) === 0.00) {
            this.rows[index].cgst = parseFloat(this.rows[index].sgst);
            this.rows[index].igst = 0.00;
            igst_value = 0.00;
        } else if (this.rows[index].igst !== '' && !isNaN(parseFloat(this.rows[index].igst)) && parseFloat(this.rows[index].igst) > 0.00) {
            this.rows[index].cgst = 0.00;
            this.rows[index].sgst = 0.00;
            igst_value = parseFloat(this.rows[index].igst);
        } else if (this.rows[index].sgst !== '' && this.rows[index].cgst !== '' && this.rows[index].igst === '') {
            this.rows[index].igst = 0.00;
            igst_value = 0.00;
        } else if (parseFloat(this.rows[index].sgst || 0) > 0.00 && parseFloat(this.rows[index].cgst || 0) > 0.00 && parseFloat(this.rows[index].igst || 0) > 0.00) {
            this.rows[index].cgst = 0.00;
            this.rows[index].sgst = 0.00;
            igst_value = parseFloat(this.rows[index].igst);
        } else {
            igst_value = 0.00;
        }

        if (this.rows[index].qty === '' || this.rows[index].qty === undefined) {
            this.rows[index].err_qty = '';
        } else if (isNaN(parseFloat(this.rows[index].qty)) || parseFloat(this.rows[index].qty) <= 0.00) {
            this.rows[index].err_qty = 'Invalid Quantity';
        } else if (!price_regex.test(this.rows[index].qty) && this.rows[index].qty !== '') {
            this.rows[index].err_qty = 'Invalid Quantity';
        } else {
            this.rows[index].err_qty = '';
        }

        // --- Start of Category-specific logic ---
        if (this.selectedCategoryType === 'silver') {
            if (this.silverInputMode === 'amount') {
                if (this.rows[index].amt === '' || this.rows[index].amt === undefined || isNaN(parseFloat(this.rows[index].amt))) {
                    this.rows[index].err_price = 'Required';
                    total = 0;
                } else {
                    this.rows[index].err_price = '';
                    total = parseFloat(this.rows[index].amt);
                }
            }  else { // 'price' mode for silver
    const pricePerGram = parseFloat(this.rows[index].price || 0);
    const weight = parseFloat(this.rows[index].weight || 0);
    const qty = parseFloat(this.rows[index].qty || 1);
    const makingCharges = parseFloat(this.rows[index].making_charges || 0);

    console.log(`[Silver][Row ${index}] Price Mode Calculation Started`);
    console.log(`[Silver][Row ${index}] pricePerGram: ${pricePerGram}`);
    console.log(`[Silver][Row ${index}] weight: ${weight}`);
    console.log(`[Silver][Row ${index}] qty: ${qty}`);
    console.log(`[Silver][Row ${index}] makingCharges (raw input): ${makingCharges}`);

    if (pricePerGram > 0 && weight > 0 && qty > 0) {
        // Making charges are considered as (making_charges * pricePerGram)
        const makingChargesValue = makingCharges * weight * qty;
        console.log(`[Silver][Row ${index}] makingChargesValue (making_charges * pricePerGram): ${makingChargesValue}`);

        const baseTotal = pricePerGram * weight * qty;
        console.log(`[Silver][Row ${index}] baseTotal (pricePerGram * weight * qty): ${baseTotal}`);

        total = (baseTotal + makingChargesValue);
        console.log(`[Silver][Row ${index}] total (baseTotal + makingChargesValue): ${total}`);
    } else {
        console.warn(`[Silver][Row ${index}] Invalid inputs for pricePerGram, weight, or qty. Setting total = 0`);
        total = 0;
    }

    this.rows[index].err_price = ''; // Reset error message
    console.log(`[Silver][Row ${index}] Final total: ${total}`);
}
        } else { // Gold-specific logic
            if (this.rows[index].price === '' || this.rows[index].price === undefined) {
                this.rows[index].err_price = '';
            } else if (isNaN(parseFloat(this.rows[index].price)) || parseFloat(this.rows[index].price) <= 0.00) {
                this.rows[index].err_price = 'Invalid Price';
            } else if (!price_regex.test(this.rows[index].price) && this.rows[index].price !== '') {
                this.rows[index].err_price = 'Invalid Price';
            } else {
                this.rows[index].err_price = '';
                this.rows[index].price = parseFloat(this.rows[index].price).toFixed(3);
            }

            const netweightInputs = {
                wastage: this.rows[index].wastage,
                weight: this.rows[index].weight,
                stone_weight: this.rows[index].stone_weight
            };
            if (netweightInputs.wastage !== '' && netweightInputs.wastage !== undefined && netweightInputs.weight !== '' && netweightInputs.weight !== undefined && netweightInputs.stone_weight !== undefined) {
                const wastage = parseFloat(netweightInputs.wastage);
                const weight = parseFloat(netweightInputs.weight);
                const stone_weight = parseFloat(netweightInputs.stone_weight);
                if (isNaN(wastage) || isNaN(weight) || isNaN(stone_weight)) {
                    this.rows[index].err_weight = 'Invalid input';
                    this.rows[index].netweight = '0.000';
                } else {
                    const netweight = weight + wastage - stone_weight;
                    if (netweight < 0) {
                        this.rows[index].netweight = '0.000';
                        this.rows[index].err_weight = 'Net weight cannot be negative';
                    } else {
                        this.rows[index].netweight = netweight.toFixed(3);
                    }
                }
            } else {
                this.rows[index].netweight = '0.000';
            }

            const totalInputs = {
                price: this.rows[index].price,
                qty: this.rows[index].qty,
                carat_value: this.rows[index].selectcarat ? this.rows[index].selectcarat.carat_value : 0,
                stone_price: this.rows[index].stone_price,
                making_charges: this.rows[index].making_charges,
                netweight: this.rows[index].netweight
            };
            if (totalInputs.price !== '' && totalInputs.price !== undefined && totalInputs.qty !== '' && totalInputs.qty !== undefined && totalInputs.carat_value !== '' && totalInputs.carat_value !== undefined && totalInputs.stone_price !== '' && totalInputs.stone_price !== undefined && totalInputs.making_charges !== '' && totalInputs.making_charges !== undefined && totalInputs.netweight !== '' && totalInputs.netweight !== undefined) {
                const price = parseFloat(totalInputs.price);
                const stone_price = parseFloat(totalInputs.stone_price);
                const making_charges = parseFloat(totalInputs.making_charges);
                const qty = parseInt(totalInputs.qty);
                const grossweight = parseFloat(totalInputs.netweight);
                if (isNaN(price) || isNaN(stone_price) || isNaN(making_charges) || isNaN(qty) || isNaN(grossweight)) {
                    this.rows[index].err_weight = 'Invalid total inputs';
                    total = 0;
                } else {
                    total = ((price * grossweight) + making_charges + stone_price) * qty;
                }
            } else {
                total = 0;
            }
        }
        // --- End of Category-specific logic ---

        if (this.rows[index].percentagemd1 !== '' && this.rows[index].percentagemd1 !== undefined && !isNaN(parseFloat(this.rows[index].percentagemd1))) {
            total = total - (total * parseFloat(this.rows[index].percentagemd1)) / 100;
        }
        if (this.rows[index].amtmd1 !== '' && this.rows[index].amtmd1 !== undefined && !isNaN(parseFloat(this.rows[index].amtmd1))) {
            total = total - parseFloat(this.rows[index].amtmd1);
        }

        if (total !== undefined && total >= 0) {
            if (this.rows[index].inclusive1 === false) {
                this.rows[index].amt = total.toFixed(3);
                const amttotal = total + (total * (parseFloat(this.rows[index].sgst || 0)) / 100) + (total * (parseFloat(this.rows[index].cgst || 0)) / 100) + (total * igst_value) / 100;
                this.rows[index].amttotal = amttotal.toFixed(3);
            } else {
                const amttotal = total.toFixed(3);
                this.rows[index].amttotal = amttotal;
                const total_percentage = parseFloat(this.rows[index].sgst || 0) + parseFloat(this.rows[index].cgst || 0) + igst_value;
                const bfttotal = total * (100 / (100 + total_percentage));
                this.rows[index].amt = bfttotal.toFixed(3);
            }
        } else {
            this.rows[index].amttotal = '0.000';
            this.rows[index].amt = '0.000';
        }

        if (this.selected_pytype === 'partial' && this.totalparamtreceived !== '' && this.totalparamtreceived !== undefined && !isNaN(parseFloat(this.totalparamtreceived)) && !isNaN(parseFloat(this.totalamtpay))) {
            this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(3);
        } else if (this.selected_pytype === 'full' && this.totalamtpay !== '' && this.totalamtpay !== undefined && !isNaN(parseFloat(this.totalamtpay))) {
            this.totalamtreceived = parseFloat(this.totalamtpay).toFixed(3);
        }
    },

    // MODIFIED: finalsubmit method with validation and data prep for silver
    finalsubmit() {
        this.haserror.message = '';
        this.haserror.cust = '';
        this.haserror.shop = '';
        var submit = 0;
        var num = /^[0-9]{1,11}$/;
        var price = /^\d{1,12}(\.\d{1,6})?$/;
        var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
        var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

        for (var i = this.rows.length - 1; i >= 0; i--) {
            if (this.rows[i].selectproductrow != null) {
                if (this.selectedCategoryType === 'silver') {
                    if (this.silverInputMode === 'amount') {
                        if (this.rows[i].amt == '' || parseFloat(this.rows[i].amt) <= 0 || !price.test(this.rows[i].amt)) {
                            submit = 1;
                            this.rows[i].err_price = 'Invalid Amount';
                        } else {
                            this.rows[i].err_price = '';
                        }
                    } else { // price mode validation
                        if (this.rows[i].price == '' || parseFloat(this.rows[i].price) <= 0 || !price.test(this.rows[i].price)) {
                            submit = 1;
                            this.rows[i].err_price = 'Invalid Price/Gram';
                        } else {
                            this.rows[i].err_price = '';
                        }
                        if (this.rows[i].weight == '' || parseFloat(this.rows[i].weight) <= 0 || !price.test(this.rows[i].weight)) {
                            submit = 1;
                            this.rows[i].err_weight = 'Invalid Weight';
                        } else {
                            this.rows[i].err_weight = '';
                        }
                    }

                    if (this.rows[i].qty == '' || parseFloat(this.rows[i].qty) <= 0 || !price.test(this.rows[i].qty)) {
                        submit = 1;
                        this.rows[i].err_qty = 'Invalid Quantity';
                    } else {
                        this.rows[i].err_qty = '';
                    }

                } else { // Gold-specific validations
                    if (this.rows[i].price == '' || parseFloat(this.rows[i].price) <= 0 || !price.test(this.rows[i].price)) {
                        submit = 1; this.rows[i].err_price = 'Invalid Price';
                    } else { this.rows[i].err_price = ''; }

                    if (this.rows[i].weight == '' || parseFloat(this.rows[i].weight) <= 0 || !price.test(this.rows[i].weight)) {
                        submit = 1; this.rows[i].err_weight = 'Invalid Weight';
                    } else { this.rows[i].err_weight = ''; }
                    
                    // ... other gold validations ...
                    if (this.rows[i].making_charges == '' || parseFloat(this.rows[i].making_charges) < 0 || !price.test(this.rows[i].making_charges)) {
                        submit = 1; this.rows[i].err_making_charges = 'Invalid charges';
                    } else { this.rows[i].err_making_charges = ''; }
                    
                    if (this.rows[i].wastage == '' || parseFloat(this.rows[i].wastage) < 0 || parseFloat(this.rows[i].wastage) > 100 || !price.test(this.rows[i].wastage)) {
                        submit = 1; this.rows[i].err_wastage = 'Invalid wastage';
                    } else { this.rows[i].err_wastage = ''; }
                    
                    if (this.rows[i].stone_price == '' || parseFloat(this.rows[i].stone_price) < 0 || !price.test(this.rows[i].stone_price)) {
                        submit = 1; this.rows[i].err_stone_price = 'Invalid Stone price';
                    } else { this.rows[i].err_stone_price = ''; }
                    
                    if (this.rows[i].stone_weight == '' || parseFloat(this.rows[i].stone_weight) < 0 || !price.test(this.rows[i].stone_weight)) {
                        submit = 1; this.rows[i].err_stone_weight = 'Invalid Stone weight';
                    } else { this.rows[i].err_stone_weight = ''; }

                    if (this.rows[i].qty == '' || parseFloat(this.rows[i].qty) <= 0 || !price.test(this.rows[i].qty)) {
                        submit = 1; this.rows[i].err_qty = 'Invalid Quantity';
                    } else { this.rows[i].err_qty = ''; }
                }

                // Tax validations (common for both silver and gold)
                if ((!igstexp.test(this.rows[i]['igst']) && this.rows[i]['igst'] != '') || parseFloat(this.rows[i]['igst']) < 0) {
                    this.rows[i]['err_igst'] = 'Invalid'; submit = 1;
                } else { this.rows[i]['err_igst'] = ''; }

                if ((!tax.test(this.rows[i]['cgst']) && this.rows[i]['cgst'] != 0) || parseFloat(this.rows[i]['cgst']) < 0) {
                    this.rows[i]['err_cgst'] = 'Invalid'; submit = 1;
                } else { this.rows[i]['err_cgst'] = ''; }

                if ((!tax.test(this.rows[i]['sgst']) && this.rows[i]['sgst'] != 0) || parseFloat(this.rows[i]['sgst']) < 0) {
                    this.rows[i]['err_sgst'] = 'Invalid'; submit = 1;
                } else { this.rows[i]['err_sgst'] = ''; }
            }
        }

        if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
            if (this.selectshop == null) { this.haserror.shop = 'Please Select Shop'; }
            if (this.selectedcustomer == null) { this.haserror.cust = 'Please Select Supplier'; }
            submit = 1;
        } else {
            for (var i = this.rows.length - 1; i >= 0; i--) {
                if (this.rows[i].selectproductrow == null) {
                    this.rows.splice(i, 1);
                }
            }
            if (this.rows.length == 0) { alert('Nothing to Save'); submit = 1; }
        }

        if (submit != 0) {
            this.haserror.message = 'Please correct the errors before submitting';
            return;
        }

        // --- Data Preparation and Submission ---
        // Ensure data is consistent for silver items
        if (this.selectedCategoryType === 'silver') {
            for (let i = 0; i < this.rows.length; i++) {
                if (this.rows[i].selectproductrow == null) continue;
                this.rows[i].selectcarat = {"carat_id": "0", "carat_value": 0, "purity_percentage": 0, "company_id": null};
                
                if (this.silverInputMode === 'amount') {
                    const amt = parseFloat(this.rows[i].amt || 0);
                    const qty = parseFloat(this.rows[i].qty || 1);
                    if (amt > 0 && qty > 0) {
                        this.rows[i].price = (amt / qty).toFixed(6); // price per piece
                    } else {
                        this.rows[i].price = '0.000000';
                    }
                } else { // price mode
                    const price = parseFloat(this.rows[i].price || 0);
                    const weight = parseFloat(this.rows[i].weight || 0);
                    const qty = parseFloat(this.rows[i].qty || 1);
                    this.rows[i].amt = (price * weight * qty).toFixed(3);
                }
            }
for (let i = 0; i < this.rows.length; i++) {
  if (this.rows[i].selectproductrow) {
    // Set the pricing_type based on silverInputMode
    if (this.silverInputMode === 'amount') {
      this.rows[i].pricing_type = 'bulk';
    } else if (this.silverInputMode === 'price') {
      this.rows[i].pricing_type = 'weight';
    } else if (this.silverInputMode === 'unit') {
      this.rows[i].pricing_type = 'unit';
    }

    // Existing logic if needed
    this.price(i, this.charge);
  }
}
        }
        
        // ... (rest of the submission logic: payment checks, data object creation, http post)
        // This part seems complex but independent of my changes, so I'll leave it as is.
        var _this = this;
        // ... payment type logic ...
        if (this.selected_pytype === 'partial') {
            var chk_partail = false;
            if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
              this.totalparamtreceived = ''; this.amt_rec = 'Required'; this.bal = 0; chk_partail = true;
            }
            if (parseInt(this.bal) < 0) {
              this.totalparamtreceived = ''; this.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)'; this.bal = 0; chk_partail = true;
            }
            if (this.selected_pymode == 'cheque' && this.cheque_no == '') { this.chequeno_validate = 'Required'; chk_partail = true; }
            if (this.selected_pymode == 'cheque' && this.cheque_date == '') { this.chequedate_validate = 'Required'; chk_partail = true; }
            if (chk_partail == true) { return; }
            this.detail.totalamtpendingpay = this.bal;
        } else if (this.selected_pytype === 'full') {
            this.detail.totalamtpendingpay = 0;
            var chk_full = false;
            if (this.selected_pymode == 'cheque' && this.cheque_no == '') { this.chequeno_validate = 'Required'; chk_full = true; }
            if (this.selected_pymode == 'cheque' && this.cheque_date == '') { this.chequedate_validate = 'Required'; chk_full = true; }
            if (chk_full == true) { return; }
        } else {
            this.detail.totalamtpendingpay = this.detail.totalamtpay;
        }

        if (this.cheque_date != '') {
            var daynum = /^[0-9]{1}$/; let date = new Date(this.cheque_date);
            var year = date.getFullYear(); var month = date.getMonth() + 1; var day = date.getDate();
            if (daynum.test(month) == true) { var month = '0' + month; } else { var month = month; }
            if (daynum.test(day) == true) { var day = '0' + day; } else { var day = day; }
            var dateval = year + '-' + month + '-' + day;
        } else { var dateval = null; }
        
        this.loading = true;
        var data = {};
        data.suppliersid = this.selectedcustomer.supplier_id;
        data.shopid = this.selectshop.est_shop_id;
        data.pur_items = this.rows;
        data.total_discount = this.detail.totprddis;
        data.additional = this.detail.addition;
        data.transport = this.detail.transporadd;
        data.amt_before_tax = this.detail.tot;
        data.cgst = this.detail.cgst;
        data.sgst = this.detail.sgst;
        data.igst = this.detail.igst;
        data.taxamt = this.detail.taxamt;
        data.totalamtpay = this.detail.totalamtpay;
        data.totalamtpendingpay = this.detail.totalamtpendingpay;
        data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
        data.pay.paytype = this.selected_pytype;
        data.pay.paymode = this.selected_pymode;
        data.pay.chqno = this.cheque_no;
        data.pay.chqdt = dateval;
        data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay);
        data.carat_value = this.selectedCategoryType === 'silver' ? 0 : (this.selectcarat && this.selectcarat.carat_value ? this.selectcarat.carat_value : null);
        if (this.selectedCategoryType === 'silver') { data.product_type = 'silver'; } 
        else { delete data.product_type; }

        this.$http.post('/api/purchases/postdata', data).then(function (response) {
            if (response.data.result.status_Code == 200) {
                _this.loading = false;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = 'Purchase Added Successfully';
                setTimeout(function () { _this.haserror.message = ''; }, 2000);
                _this.redirect();
            } else if (response.data.result.status_Code == 401) {
                _this.loading = false;
                _this.haserror.message = 'Something Went Wrong';
                setTimeout(function () { _this.haserror.message = ''; }, 3000);
            }
        }).catch(function (error) {
            _this.loading = false;
            console.log(error.response);
        });
    },

  reset(){

  this.selectcarat=null
  this.making_charges=''
  this.weight=''
  this.netweight=''
  this.wastage=''

  this.stone_price=''
  this.stone_weight=''
  this.select_shop=null
  this.detail.totprddis=''
  this.detail.addition=''
  this.detail.tot=''


  this.detail.taxamt=''
  this.detail.totalamtpay=''
  this.detail.totalamtpendingpay=''
  this.chng=0
  this.bal=0.0000
  this.totalamtreceived=''
  this.cheque_no=''
  this.cheque_date=''
  this.addr=[]

  this.selected_pymode='cash'
  this.selected_pytype='full'

  for (var i = this.rows.length-1; i >=0;  i--) {
    this.rows.splice(i,1);
  }
  for (var i = 0; i <=2; i++){
   this.rows.push({ caratval:[],selectcarat:null,weightlist:[],selectweight:null,making_charges:'',igst:0.00,weight:'',netweight:'',wastage:'',stone_price:'',stone_weight:'',err_stone_weight:'',err_stone_price:'' ,productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:0,wastage:'',qty:'',amt:'',amttotal:0,percentagemd1:'', amtmd1:'',variantrow:'n/a',avaqty:'',show:false,show1:false,show2:false,priceqty:'', inclusive1:false,err_qty:'', err_price:'',err_making_charges:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:''})
 }
},

  redirect()
  {
      // console.log("redirect")
     setTimeout(function(){   window.location.href="#/purchase/purchaseentry"}, 3000);

  },


  },

}
</script>

<style type="text/css">
  .bell{
    -webkit-animation: ring 4s .7s ease-in-out infinite;
    -webkit-transform-origin: 50% 4px;
    -moz-animation: ring 4s .7s ease-in-out infinite;
    -moz-transform-origin: 50% 4px;
    animation: ring 4s .7s ease-in-out infinite;
    transform-origin: 50% 4px;
  }

  @-webkit-keyframes ring {
    0% { -webkit-transform: rotateZ(0); }
    1% { -webkit-transform: rotateZ(30deg); }
    3% { -webkit-transform: rotateZ(-28deg); }
    5% { -webkit-transform: rotateZ(34deg); }
    7% { -webkit-transform: rotateZ(-32deg); }
    9% { -webkit-transform: rotateZ(30deg); }
    11% { -webkit-transform: rotateZ(-28deg); }
    13% { -webkit-transform: rotateZ(26deg); }
    15% { -webkit-transform: rotateZ(-24deg); }
    17% { -webkit-transform: rotateZ(22deg); }
    19% { -webkit-transform: rotateZ(-20deg); }
    21% { -webkit-transform: rotateZ(18deg); }
    23% { -webkit-transform: rotateZ(-16deg); }
    25% { -webkit-transform: rotateZ(14deg); }
    27% { -webkit-transform: rotateZ(-12deg); }
    29% { -webkit-transform: rotateZ(10deg); }
    31% { -webkit-transform: rotateZ(-8deg); }
    33% { -webkit-transform: rotateZ(6deg); }
    35% { -webkit-transform: rotateZ(-4deg); }
    37% { -webkit-transform: rotateZ(2deg); }
    39% { -webkit-transform: rotateZ(-1deg); }
    41% { -webkit-transform: rotateZ(1deg); }

    43% { -webkit-transform: rotateZ(0); }
    100% { -webkit-transform: rotateZ(0); }
  }

  @-moz-keyframes ring {
    0% { -moz-transform: rotate(0); }
    1% { -moz-transform: rotate(30deg); }
    3% { -moz-transform: rotate(-28deg); }
    5% { -moz-transform: rotate(34deg); }
    7% { -moz-transform: rotate(-32deg); }
    9% { -moz-transform: rotate(30deg); }
    11% { -moz-transform: rotate(-28deg); }
    13% { -moz-transform: rotate(26deg); }
    15% { -moz-transform: rotate(-24deg); }
    17% { -moz-transform: rotate(22deg); }
    19% { -moz-transform: rotate(-20deg); }
    21% { -moz-transform: rotate(18deg); }
    23% { -moz-transform: rotate(-16deg); }
    25% { -moz-transform: rotate(14deg); }
    27% { -moz-transform: rotate(-12deg); }
    29% { -moz-transform: rotate(10deg); }
    31% { -moz-transform: rotate(-8deg); }
    33% { -moz-transform: rotate(6deg); }
    35% { -moz-transform: rotate(-4deg); }
    37% { -moz-transform: rotate(2deg); }
    39% { -moz-transform: rotate(-1deg); }
    41% { -moz-transform: rotate(1deg); }

    43% { -moz-transform: rotate(0); }
    100% { -moz-transform: rotate(0); }
  }

  @keyframes ring {
    0% { transform: rotate(0); }
    1% { transform: rotate(30deg); }
    3% { transform: rotate(-28deg); }
    5% { transform: rotate(34deg); }
    7% { transform: rotate(-32deg); }
    9% { transform: rotate(30deg); }
    11% { transform: rotate(-28deg); }
    13% { transform: rotate(26deg); }
    15% { transform: rotate(-24deg); }
    17% { transform: rotate(22deg); }
    19% { transform: rotate(-20deg); }
    21% { transform: rotate(18deg); }
    23% { transform: rotate(-16deg); }
    25% { transform: rotate(14deg); }
    27% { transform: rotate(-12deg); }
    29% { transform: rotate(10deg); }
    31% { transform: rotate(-8deg); }
    33% { transform: rotate(6deg); }
    35% { transform: rotate(-4deg); }
    37% { transform: rotate(2deg); }
    39% { transform: rotate(-1deg); }
    41% { transform: rotate(1deg); }
    43% { transform: rotate(0); }
    100% { transform: rotate(0); }
  }
  .modal-title{
    color:black;
    font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/purches/addpurches.vue